import * as tslib_1 from "tslib";
import { Subject } from 'rxjs';
import { MapApi } from '../api/map-api';
import { UserApi } from '../api/user-api';
import { CreateBasemapsFromConfig } from '../components/mapComponents/basemap-switcher/basemap-config';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { LayerService } from '../services/layer.service';
import { HeatmapService } from './heatmap.service';
import * as i0 from "@angular/core";
import * as i1 from "./layer.service";
import * as i2 from "./heatmap.service";
import * as i3 from "../api/map-api";
import * as i4 from "../api/user-api";
var MapService = /** @class */ (function () {
    function MapService(layerService, heatmapService, mapApi, userApi) {
        var _this = this;
        this.layerService = layerService;
        this.heatmapService = heatmapService;
        this.mapApi = mapApi;
        this.userApi = userApi;
        this.mapStatus = new Subject();
        this.getMaps = function (mapIds, overrideProps) {
            if (overrideProps === void 0) { overrideProps = null; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.mapApi.getMaps(mapIds, overrideProps)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.openMap = function (map, startWithVisibleLayersTurnedOff) {
            if (startWithVisibleLayersTurnedOff === void 0) { startWithVisibleLayersTurnedOff = false; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _a, e_1, _b, e_2, _c, e_3, _d, Extent, data, _e, _f, layer, basemapSetup, _g, _h, _j, basemapConfig, _k, pennDOTBasemapConfig, _l, layerReferencesInBulk, _m, _o, layer, _p, _q, childLayer, e_2_1;
                return tslib_1.__generator(this, function (_r) {
                    switch (_r.label) {
                        case 0:
                            this.mapStatus.next('loading');
                            return [4 /*yield*/, Promise.all([ESRI.Extent])];
                        case 1:
                            _a = tslib_1.__read.apply(void 0, [_r.sent(), 1]), Extent = _a[0];
                            data = JSON.parse(map.data);
                            if (data && data.layers && startWithVisibleLayersTurnedOff) {
                                try {
                                    for (_e = tslib_1.__values(data.layers), _f = _e.next(); !_f.done; _f = _e.next()) {
                                        layer = _f.value;
                                        layer.visible = false;
                                    }
                                }
                                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                finally {
                                    try {
                                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                                    }
                                    finally { if (e_1) throw e_1.error; }
                                }
                            }
                            // We should provide prompt to save map before wiping all layers.
                            this.mcMapView.resetMapProps(map);
                            if (this.isValidExtent(data.extent)) {
                                this.mcMapView.extent = Extent.fromJSON(data.extent);
                            }
                            if (!map.basemap) return [3 /*break*/, 14];
                            basemapSetup = JSON.parse(map.basemap);
                            _g = basemapSetup.type;
                            switch (_g) {
                                case 'ID': return [3 /*break*/, 2];
                                case 'BING': return [3 /*break*/, 4];
                                case 'CONFIG': return [3 /*break*/, 6];
                            }
                            return [3 /*break*/, 10];
                        case 2:
                            _h = this.layerService.mapRef;
                            return [4 /*yield*/, this.createBasemapFromId(basemapSetup.id)];
                        case 3:
                            _h.basemap = _r.sent();
                            return [3 /*break*/, 14];
                        case 4:
                            _j = this.layerService.mapRef;
                            return [4 /*yield*/, this.createBingBasemap(basemapSetup.id)];
                        case 5:
                            _j.basemap = _r.sent();
                            return [3 /*break*/, 14];
                        case 6: return [4 /*yield*/, this.createBasemapConfig(basemapSetup.id)];
                        case 7:
                            basemapConfig = _r.sent();
                            return [4 /*yield*/, this.layerService.getLayerCopyRight(basemapConfig)];
                        case 8:
                            _r.sent();
                            _k = this.layerService.mapRef;
                            return [4 /*yield*/, CreateBasemapsFromConfig(basemapConfig)];
                        case 9:
                            _k.basemap = _r.sent();
                            return [3 /*break*/, 14];
                        case 10: return [4 /*yield*/, this.createBasemapConfig('PennDOT')];
                        case 11:
                            pennDOTBasemapConfig = _r.sent();
                            return [4 /*yield*/, this.layerService.getLayerCopyRight(pennDOTBasemapConfig)];
                        case 12:
                            _r.sent();
                            _l = this.layerService.mapRef;
                            return [4 /*yield*/, CreateBasemapsFromConfig(pennDOTBasemapConfig)];
                        case 13:
                            _l.basemap = _r.sent();
                            return [3 /*break*/, 14];
                        case 14:
                            layerReferencesInBulk = [];
                            _r.label = 15;
                        case 15:
                            _r.trys.push([15, 23, 24, 25]);
                            _m = tslib_1.__values(data.layers), _o = _m.next();
                            _r.label = 16;
                        case 16:
                            if (!!_o.done) return [3 /*break*/, 22];
                            layer = _o.value;
                            if (!layer.id) return [3 /*break*/, 17];
                            layerReferencesInBulk.push(layer);
                            return [3 /*break*/, 21];
                        case 17:
                            if (!layer.layers) return [3 /*break*/, 21];
                            if (!(layerReferencesInBulk.length > 0)) return [3 /*break*/, 19];
                            return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(layerReferencesInBulk, null, false, map.isSystem)];
                        case 18:
                            _r.sent();
                            _r.label = 19;
                        case 19:
                            layerReferencesInBulk = [];
                            try {
                                for (_p = tslib_1.__values(layer.layers), _q = _p.next(); !_q.done; _q = _p.next()) {
                                    childLayer = _q.value;
                                    childLayer.groupParent = {
                                        name: layer.name,
                                        visible: layer.visible,
                                        isOpen: layer.isExpanded,
                                        splitThemeJSON: layer.splitThemeJSON
                                    };
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (_q && !_q.done && (_d = _p.return)) _d.call(_p);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(layer.layers, null, false, map.isSystem)];
                        case 20:
                            _r.sent();
                            _r.label = 21;
                        case 21:
                            _o = _m.next();
                            return [3 /*break*/, 16];
                        case 22: return [3 /*break*/, 25];
                        case 23:
                            e_2_1 = _r.sent();
                            e_2 = { error: e_2_1 };
                            return [3 /*break*/, 25];
                        case 24:
                            try {
                                if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7 /*endfinally*/];
                        case 25:
                            if (!(layerReferencesInBulk.length > 0)) return [3 /*break*/, 27];
                            return [4 /*yield*/, this.layerService.addMapcoreLayersToMap(layerReferencesInBulk, null, false, map.isSystem, data.paramConfig)];
                        case 26:
                            _r.sent();
                            _r.label = 27;
                        case 27:
                            this.mapStatus.next('loaded');
                            return [2 /*return*/];
                    }
                });
            });
        };
    }
    MapService.prototype.deleteMaps = function (mapIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, mapIds_1, mapIds_1_1, id, e_4_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, 6, 7]);
                        mapIds_1 = tslib_1.__values(mapIds), mapIds_1_1 = mapIds_1.next();
                        _b.label = 1;
                    case 1:
                        if (!!mapIds_1_1.done) return [3 /*break*/, 4];
                        id = mapIds_1_1.value;
                        return [4 /*yield*/, this.mapApi.deleteMap(id)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        mapIds_1_1 = mapIds_1.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_4_1 = _b.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (mapIds_1_1 && !mapIds_1_1.done && (_a = mapIds_1.return)) _a.call(mapIds_1);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MapService.prototype.getSystemMaps = function (appId, includeLayers) {
        if (includeLayers === void 0) { includeLayers = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = 'id, name, uniqueName, isSystem, isPublic, description, categories{name}, data, createdDate, lastEditedDate, basemap';
                        if (includeLayers) {
                            props += ', layers{name}';
                        }
                        return [4 /*yield*/, this.mapApi.getSystemMaps(appId, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapService.prototype.getUserMaps = function (userId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var appIdFilter, props;
            return tslib_1.__generator(this, function (_a) {
                appIdFilter = '';
                if (applicationId) {
                    appIdFilter = "(applicationId:" + applicationId + ")";
                }
                props = "firstName, lastName, email, userMaps" + appIdFilter + " { accessLevel, userId, map(isSystem: false) { id, name, description, data, isSystem, isPublic, createdDate, lastEditedDate, basemap },  sharedWith { accessLevel, userId }}";
                return [2 /*return*/, this.mapApi.getUserMaps(userId, props)];
            });
        });
    };
    MapService.prototype.getUserMap = function (userId, mapId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapApi.getUserMap(userId, mapId, applicationId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapService.prototype.getUserMapsFolders = function (userId, applicationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = "id, folders(category:\"maps\", applicationId:" + applicationId + ") {id, applicationId, name,  parentUserFolderId, maps{id} }";
                        return [4 /*yield*/, this.mapApi.getUserMapsFolders(userId, props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapService.prototype.getMapUsers = function (mapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        props = 'id,  users {id, email, firstName, lastName }';
                        return [4 /*yield*/, this.mapApi.getMaps([mapId], props)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapService.prototype.isValidExtent = function (extent) {
        return extent && extent.xmin && extent.xmax && extent.ymin && extent.ymax;
    };
    MapService.prototype.resetMap = function () {
        this.mcMapView.resetMapProps();
    };
    MapService.prototype.retrieveMap = function (map, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapId, props, maps, sysMap, props, result, userMap, mapObj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mapId = map.id;
                        if (!map.isSystem) return [3 /*break*/, 2];
                        props = 'id, name, uniqueName, isSystem, isPublic, description';
                        return [4 /*yield*/, this.mapApi.getMaps([mapId], props)];
                    case 1:
                        maps = _a.sent();
                        if (maps && maps.length > 0) {
                            sysMap = maps[0];
                            map.accessLevel = 'VIEWER';
                            return [2 /*return*/, sysMap];
                        }
                        else {
                            return [2 /*return*/, map];
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        props = "userMaps { accessLevel, map (id:" + mapId + ") {id, name, uniqueName, isSystem, isPublic, description} }";
                        return [4 /*yield*/, this.mapApi.getUserMaps(userId, props)];
                    case 3:
                        result = _a.sent();
                        //TODO: sanitizeMap
                        if (result && result.length > 0 && result[0].userMaps.length > 0) {
                            userMap = result[0].userMaps.find(function (um) {
                                return um.map && um.map.id === mapId;
                            });
                            if (userMap) {
                                mapObj = userMap.map;
                                mapObj.accessLevel = userMap.accessLevel;
                                return [2 /*return*/, mapObj];
                            }
                            else {
                                return [2 /*return*/, map];
                            }
                        }
                        else {
                            return [2 /*return*/, map];
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MapService.prototype.shareMap = function (mapId, data, notifyUserByEmail, sharedUserIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var emailSubject, emailBody, resharedEmailSubject, resharedEmailBody, emailmessage, message, userIds, userIdShared, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emailSubject = '';
                        emailBody = '';
                        resharedEmailSubject = '';
                        resharedEmailBody = '';
                        emailmessage = data.data.map(function (u) { return u.message; });
                        message = emailmessage.find(function () { return true; });
                        if (notifyUserByEmail) {
                            resharedEmailSubject = environment.appName + ': Resharing Map';
                            emailSubject = environment.appName + ': New Shared Map';
                            resharedEmailBody = this._buildReSharedMessage(message, data.title ? data.title : data.data[0].title, mapId);
                            emailBody = this._buildMessage(message, data.title ? data.title : data.data[0].title, mapId);
                        }
                        userIds = [];
                        userIdShared = [];
                        data.recipients.forEach(function (recipient) {
                            var e_5, _a;
                            try {
                                for (var sharedUserIds_1 = tslib_1.__values(sharedUserIds), sharedUserIds_1_1 = sharedUserIds_1.next(); !sharedUserIds_1_1.done; sharedUserIds_1_1 = sharedUserIds_1.next()) {
                                    var sharedUserId = sharedUserIds_1_1.value;
                                    var userShared = sharedUserId.includes(recipient.id);
                                    if (userShared) {
                                        userIdShared.push(recipient.id);
                                    }
                                    else {
                                        userIds.push(recipient.id);
                                    }
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (sharedUserIds_1_1 && !sharedUserIds_1_1.done && (_a = sharedUserIds_1.return)) _a.call(sharedUserIds_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                        });
                        if (!(userIds.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mapApi.shareMap(userIds, mapId, emailSubject, emailBody)];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(userIdShared.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.mapApi.shareMap(userIdShared, mapId, resharedEmailSubject, resharedEmailBody)];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    MapService.prototype.shareMaps = function (mapIds, data, notifyUserByEmail, sharedUserIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var emailSubject, emailBody, resharedEmailSubject, resharedEmailBody, emailmessage, message, mapTitles, userIds, userIdShared, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        emailSubject = '';
                        emailBody = '';
                        resharedEmailSubject = '';
                        resharedEmailBody = '';
                        emailmessage = data.data.map(function (u) { return u.message; });
                        message = emailmessage.find(function () { return true; });
                        mapTitles = data.data.map(function (map) { return map.title; });
                        if (notifyUserByEmail) {
                            resharedEmailSubject = environment.appName + (mapIds.length > 1 ? ': Resharing Maps' : ': Resharing Map');
                            emailSubject = environment.appName + (mapIds.length > 1 ? ': New Shared Maps' : ': New Shared Map');
                            resharedEmailBody = this._buildReSharedMessageMulti(message, mapTitles, mapIds);
                            emailBody = this._buildMessageMulti(message, mapTitles, mapIds);
                        }
                        userIds = [];
                        userIdShared = [];
                        data.recipients.forEach(function (recipient) {
                            var e_6, _a;
                            try {
                                for (var sharedUserIds_2 = tslib_1.__values(sharedUserIds), sharedUserIds_2_1 = sharedUserIds_2.next(); !sharedUserIds_2_1.done; sharedUserIds_2_1 = sharedUserIds_2.next()) {
                                    var sharedUserId = sharedUserIds_2_1.value;
                                    var userShared = sharedUserId.includes(recipient.id);
                                    if (userShared) {
                                        if (!userIdShared.includes(recipient.id)) {
                                            userIdShared.push(recipient.id);
                                        }
                                    }
                                    else {
                                        if (!userIds.includes(recipient.id)) {
                                            userIds.push(recipient.id);
                                        }
                                    }
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (sharedUserIds_2_1 && !sharedUserIds_2_1.done && (_a = sharedUserIds_2.return)) _a.call(sharedUserIds_2);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                        });
                        if (!(userIds.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mapApi.shareMaps(userIds, mapIds, emailSubject, emailBody)];
                    case 1:
                        result = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(userIdShared.length > 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.mapApi.shareMaps(userIdShared, mapIds, resharedEmailSubject, resharedEmailBody)];
                    case 3:
                        result = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    MapService.prototype.unShareMap = function (userIds, mapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapApi.unShareMap(userIds, mapId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapService.prototype.getMapUrl = function (mapId) {
        var baseUrl = environment.deepLinkBaseUrl || window.location.href.split('?')[0];
        return baseUrl + "?map-id=" + mapId;
    };
    MapService.prototype.copyMaps = function (mapIds, appId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapApi.copyMaps(mapIds, appId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MapService.prototype.setTokenPcit = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.mapApi.setTokenCookie(token, environment.apiBaseUrl + "/cookies/pcit")];
            });
        });
    };
    MapService.prototype.turnOnHeatmapMode = function (layer, heatmapRenderer) {
        if (heatmapRenderer === void 0) { heatmapRenderer = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.heatmapService.updateHeatmapLayers(layer, heatmapRenderer);
                return [2 /*return*/];
            });
        });
    };
    MapService.prototype._buildMessage = function (message, title, mapId) {
        var appName = environment.appName ? environment.appName : '';
        var mapUrl = this.getMapUrl(mapId);
        var template = "I've shared a new map with you from " + appName + " named " + title + ". You can view the map in " + appName + " by going to the Maps dialog.\n\n " + mapUrl;
        if (message) {
            template += "\n\nMessage from user: " + message;
        }
        return template;
    };
    MapService.prototype._buildMessageMulti = function (message, titles, mapIds) {
        var _this = this;
        var appName = environment.appName ? environment.appName : '';
        var mapUrls = mapIds.map(function (id) { return _this.getMapUrl(id); });
        var mapsText = mapUrls.map(function (url, index) { return titles[index] + ": " + url; });
        var template = "I've shared maps with you from " + appName + ". You can view the maps in " + appName + " by going to the Maps dialog.\n\n" + mapsText.join('\n');
        if (message) {
            template += "\n\nMessage from user: " + message;
        }
        return template;
    };
    MapService.prototype._buildReSharedMessage = function (message, title, mapId) {
        var appName = environment.appName ? environment.appName : '';
        var mapUrl = this.getMapUrl(mapId);
        var template = "I am resharing a map with you from " + appName + " named " + title + ". You can view the map in " + appName + " by going to the Maps dialog.\n\n " + mapUrl;
        if (message) {
            template += "\n\nMessage from user: " + message;
        }
        return template;
    };
    MapService.prototype._buildReSharedMessageMulti = function (message, titles, mapIds) {
        var _this = this;
        var appName = environment.appName ? environment.appName : '';
        var mapUrls = mapIds.map(function (id) { return _this.getMapUrl(id); });
        var mapsText = mapUrls.map(function (url, index) { return titles[index] + ": " + url; });
        var template = "I am resharing maps with you from " + appName + ". You can view the maps in " + appName + " by going to the Maps dialog.\n\n" + mapsText.join('\n');
        if (message) {
            template += "\n\nMessage from user: " + message;
        }
        return template;
    };
    MapService.prototype.clearLoading = function () {
        this.mapStatus.next('loaded');
    };
    MapService.prototype.saveMap = function (map, isNewMap, parentFolderId, newFolder) {
        if (isNewMap === void 0) { isNewMap = false; }
        if (parentFolderId === void 0) { parentFolderId = 0; }
        if (newFolder === void 0) { newFolder = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_7, _a, e_8, _b, layers, mapLayers, layers_1, layers_1_1, layer, mapcoreLayer, _c, _d, groupedLayer, groupedMapcoreLayer, basemapIds, currentFolder;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        layers = this.layerService.mapRef.layers.items;
                        layers = layers.filter(function (x) {
                            return x.mapcoreProps &&
                                (x.mapcoreProps.parentId || x.mapcoreProps.url || 'graphics' in x || 'source' in x || x.type === 'group') &&
                                !x.mapcoreProps.hideInLegend && (!x.listMode || x.listMode !== 'hide');
                        });
                        mapLayers = [];
                        try {
                            for (layers_1 = tslib_1.__values(layers), layers_1_1 = layers_1.next(); !layers_1_1.done; layers_1_1 = layers_1.next()) {
                                layer = layers_1_1.value;
                                if (layer.type !== 'group') {
                                    mapcoreLayer = this.layerService.getLayerForSaveMap(layer, isNewMap);
                                    mapLayers.push(mapcoreLayer);
                                }
                                else {
                                    try {
                                        for (_c = tslib_1.__values(layer.layers.toArray()), _d = _c.next(); !_d.done; _d = _c.next()) {
                                            groupedLayer = _d.value;
                                            groupedMapcoreLayer = this.layerService.getLayerForSaveMap(groupedLayer, isNewMap);
                                            mapLayers.push(groupedMapcoreLayer);
                                        }
                                    }
                                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                                    finally {
                                        try {
                                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                        }
                                        finally { if (e_8) throw e_8.error; }
                                    }
                                }
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                        if (this.layerService.mapRef.basemap) {
                            basemapIds = ['terrain', 'streets-vector', 'satellite', 'hybrid', 'topo-vector', 'gray-vector', 'osm'];
                            if (basemapIds.includes(this.layerService.mapRef.basemap.id)) {
                                map.basemap = JSON.stringify({ type: 'ID', id: "" + this.layerService.mapRef.basemap.id });
                            }
                            else if (this.layerService.mapRef.basemap.id.includes('Bing')) {
                                map.basemap = JSON.stringify({ type: 'BING', id: "" + this.layerService.mapRef.basemap.id });
                            }
                            else {
                                map.basemap = JSON.stringify({ type: 'CONFIG', id: "" + this.layerService.mapRef.basemap.id });
                            }
                        }
                        if (map.isSystem || isNewMap) {
                            map.id = null;
                            map.isSystem = false;
                            map.layers = null;
                        }
                        map.extentJSON = JSON.stringify(this.mcMapView.extent.toJSON());
                        if (!map) {
                            map = this.mcMapView.mapcoreViewProps;
                        }
                        return [4 /*yield*/, this.mapApi.saveMap(map, mapLayers, environment.appId)];
                    case 1:
                        map = _e.sent();
                        this.mcMapView.mapcoreViewProps = map;
                        if (!newFolder) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userApi.createNewUserFolder(newFolder)];
                    case 2:
                        currentFolder = _e.sent();
                        if (currentFolder) {
                            map.parentFolderId = currentFolder.id;
                        }
                        _e.label = 3;
                    case 3:
                        if (!map.parentFolderId) {
                            map.parentFolderId = parentFolderId;
                        }
                        if (!map.parentFolderId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.mapApi.saveMapToUserFolder(map.id, map.parentFolderId)];
                    case 4:
                        _e.sent();
                        _e.label = 5;
                    case 5: return [2 /*return*/, map.id];
                }
            });
        });
    };
    MapService.prototype.createBasemapFromId = function (basemapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Basemap;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!Basemap) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all([ESRI.Basemap])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), Basemap = _a[0];
                        _b.label = 2;
                    case 2: return [2 /*return*/, Basemap.fromId(basemapId)];
                }
            });
        });
    };
    MapService.prototype.createBingBasemap = function (basemapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bingBasemap, bingSetupConfig;
            return tslib_1.__generator(this, function (_a) {
                // default to same as BingMapsRoad
                switch (basemapId.slice(0, -1)) {
                    case 'BingMapsRoad':
                        bingSetupConfig = {
                            style: 'road',
                            title: 'Bing Streets',
                            thumbnailUrl: environment.bingBasemaps.thumbnails.street,
                            id: basemapId
                        };
                        bingBasemap = this.createBingBasemapFromConfig(bingSetupConfig);
                        break;
                    case 'BingMapsAerial':
                        bingSetupConfig = {
                            style: 'aerial',
                            title: 'Bing Imagery',
                            thumbnailUrl: environment.bingBasemaps.thumbnails.imagery,
                            id: basemapId
                        };
                        bingBasemap = this.createBingBasemapFromConfig(bingSetupConfig);
                        break;
                    case 'BingMapsHybrid':
                        bingSetupConfig = {
                            style: 'hybrid',
                            title: 'Bing Imagery w/ Labels',
                            thumbnailUrl: environment.bingBasemaps.thumbnails.hybrid,
                            id: basemapId
                        };
                        bingBasemap = this.createBingBasemapFromConfig(bingSetupConfig);
                        break;
                    default:
                        bingSetupConfig = {
                            style: 'road',
                            title: 'Bing Streets',
                            thumbnailUrl: environment.bingBasemaps.thumbnails.street,
                            id: basemapId
                        };
                        bingBasemap = this.createBingBasemapFromConfig(bingSetupConfig);
                        break;
                }
                return [2 /*return*/, bingBasemap];
            });
        });
    };
    MapService.prototype.createBingBasemapFromConfig = function (bingSetupConfig) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, Basemap, BingMapLayer, bingBasemap, opacityModifier;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([ESRI.Basemap, ESRI.BingMapsLayer])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), Basemap = _a[0], BingMapLayer = _a[1];
                        opacityModifier = 0.000001;
                        bingBasemap = new Basemap(tslib_1.__assign({ baseLayers: [
                                new BingMapLayer(tslib_1.__assign({}, bingSetupConfig, { key: environment.bingBasemaps.key, opacity: 1 - opacityModifier //this setting of opacity is a work around for ESRI comparisons that just take into consideration type, url, min scale, max scale, visibility, and opacity. In the
                                 }))
                            ] }, bingSetupConfig));
                        return [2 /*return*/, bingBasemap];
                }
            });
        });
    };
    MapService.prototype.createBasemapConfig = function (basemapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var basemapConfig;
            return tslib_1.__generator(this, function (_a) {
                switch (basemapId) {
                    case 'Elevation':
                        basemapConfig = {
                            tileUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile',
                            thumbnailTile: '/15/12358/9365',
                            tileTemplate: '/{level}/{row}/{col}',
                            title: 'Elevation'
                        };
                        break;
                    case 'Topographic DRG':
                        basemapConfig = {
                            tileUrl: 'https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile',
                            thumbnailTile: '/7/48/36',
                            tileTemplate: '/{level}/{row}/{col}',
                            title: 'Topographic DRG'
                        };
                        break;
                    // MIQ fazed this out with Esri's terrain basemap.. Onemap and others still use
                    case 'Terrain':
                        basemapConfig = {
                            tileUrl: 'https://tiles.stadiamaps.com/tiles/stamen_terrain',
                            thumbnailTile: '/10/177/409.png',
                            tileTemplate: '/{level}/{col}/{row}.png',
                            title: 'Terrain'
                        };
                        break;
                    case 'PEMA':
                        basemapConfig = {
                            tileUrl: 'https://gis.penndot.pa.gov/img/rest/services/imagery/PEMA_2018/ImageServer/tile',
                            thumbnailTile: '/13/3093/2346',
                            tileTemplate: '/{level}/{row}/{col}',
                            title: 'PEMA'
                        };
                        break;
                    default:
                        basemapConfig = environment.pennDotBaseMap;
                        break;
                }
                return [2 /*return*/, basemapConfig];
            });
        });
    };
    MapService.ngInjectableDef = i0.defineInjectable({ factory: function MapService_Factory() { return new MapService(i0.inject(i1.LayerService), i0.inject(i2.HeatmapService), i0.inject(i3.MapApi), i0.inject(i4.UserApi)); }, token: MapService, providedIn: "root" });
    return MapService;
}());
export { MapService };
